import React from 'react';
import { ACTIVITY_STATUS, fmtDate, memberName } from './constants';

const DAY = 86400000;
const toMs = (d) => new Date(`${String(d).slice(0, 10)}T00:00:00`).getTime();

export const GanttTimeline = ({ activities: all, members, onOpen, cpm }) => {
  const activities = cpm ? all.filter((a) => cpm.activities[a.id]) : all;
  if (!activities.length) return <p className="py-8 text-center text-sm text-slate-500" data-testid="gantt-empty">Agrega actividades para ver la línea de tiempo.</p>;
  const start = Math.min(...activities.map((a) => toMs(a.start_date)));
  const lateEnds = cpm ? Object.values(cpm.activities).map((x) => toMs(x.late_finish)) : [];
  const end = Math.max(...activities.map((a) => toMs(a.end_date)), ...lateEnds) + DAY;
  const span = end - start;
  const pct = (ms) => `${((ms - start) / span) * 100}%`;
  const today = Date.now();
  const months = [];
  for (let d = new Date(start); d.getTime() < end; d = new Date(d.getFullYear(), d.getMonth() + 1, 1)) months.push(Math.max(d.getTime(), start));
  const sorted = [...activities].sort((a, b) => toMs(a.start_date) - toMs(b.start_date));
  return (
    <div className="overflow-x-auto" data-testid="gantt-timeline">
      <div className="min-w-[760px]">
        <div className="relative ml-[220px] h-6 border-b border-slate-200 text-[11px] text-slate-500 dark:border-slate-700">
          {months.map((m) => <span key={m} className="absolute top-1" style={{ left: pct(m) }}>{new Date(m).toLocaleDateString('es', { month: 'short', year: '2-digit' })}</span>)}
        </div>
        <div className="relative">
          {today > start && today < end && <div className="absolute bottom-0 top-0 z-10 w-px bg-red-400" style={{ left: `calc(220px + (100% - 220px) * ${(today - start) / span})` }} data-testid="gantt-today" />}
          {sorted.map((a) => (
            <div key={a.id} className="flex items-center border-b border-slate-100 py-1.5 dark:border-slate-800" data-testid={`gantt-row-${a.id}`}>
              <div className="w-[220px] shrink-0 pr-3">
                <p className="truncate text-sm font-medium text-slate-800 dark:text-slate-200">{a.title}</p>
                <p className="truncate text-[11px] text-slate-500">{memberName(members, a.assignee_user_id)} · {fmtDate(a.start_date)} → {fmtDate(a.end_date)}</p>
              </div>
              <div className="relative h-7 flex-1">
                {cpm && cpm.activities[a.id]?.slack_days > 0 && (
                  <span className="absolute top-2.5 h-2 rounded border border-dashed border-slate-400/70" title={`Holgura: ${cpm.activities[a.id].slack_days} días`}
                    style={{ left: pct(toMs(cpm.activities[a.id].early_finish) + DAY), width: `${(cpm.activities[a.id].slack_days * DAY / span) * 100}%` }} data-testid={`gantt-slack-${a.id}`} />
                )}
                <button type="button" onClick={() => onOpen(a)} title={`${a.title} · ${a.progress}%`}
                  className={`absolute top-1 h-5 overflow-hidden rounded-md bg-slate-200 transition-opacity duration-150 hover:opacity-80 dark:bg-slate-700 ${cpm?.activities[a.id]?.critical ? 'ring-2 ring-red-500' : ''}`}
                  style={cpm ? { left: pct(toMs(cpm.activities[a.id].early_start)), width: `max(6px, ${(cpm.activities[a.id].duration * DAY / span) * 100}%)` }
                    : { left: pct(toMs(a.start_date)), width: `max(6px, ${((toMs(a.end_date) + DAY - toMs(a.start_date)) / span) * 100}%)` }}
                  data-critical={cpm?.activities[a.id]?.critical ? 'true' : 'false'}
                  data-testid={`gantt-bar-${a.id}`}>
                  <span className={`block h-full ${ACTIVITY_STATUS[a.status].bar}`} style={{ width: `${a.progress}%` }} />
                </button>
                {a.depends_on?.length > 0 && <span className="absolute -top-0.5 text-[10px] text-slate-400" style={{ left: pct(toMs(a.start_date)) }}>↳ {a.depends_on.length} dep.</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
